import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { UserAccess } from 'components/user-access';
import { PageRestricted } from 'pages/errors/page-restricted';
import { PolicySignoffListing } from 'pages/policy/listing';
import { DocumentEntityListing } from 'pages/documents/listing';
import { Layout } from 'pages/employee/documents/Layout';
import PropTypes from 'prop-types';

export function Documents({ employeeId }) {

    const id = Number(employeeId);

    return (
        <UserAccess perform={["Documents:View"]}
            yes={() => (
                <Layout employeeId={id}>
                    <Routes>
                        <Route path="document-list" element={<DocumentEntityListing
                                entityType="employee"
                                entityId={id}
                                showTitle={false}
                                filterName={'documents-employee'}
                            />} />
                        <Route path="policies" element={<PolicySignoffListing title={"Policies"}
                                employeeId={id} />} />
                        <Route path="" element={<Navigate to="document-list" replace />} />
                    </Routes>
                </Layout>
            )}
            no={() => (
                <PageRestricted />
            )}
        />
    );
}

Documents.propTypes = {
    employeeId: PropTypes.string.isRequired
};